(function () {
    angular.module('tmx-app').controller('creditSummaryCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'BranchService',
        'CreditSummaryService',
        'TMX_FINANCE_CONSTANTS',
        'cacheStore',

        function creditSummaryCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            BranchService,
            CreditSummaryService,
            TMX_FINANCE_CONSTANTS,
            cacheStore) {
            var creditSummaryVM = this;
            creditSummaryVM.menu = menu;
            creditSummaryVM.gridData = new kendo.data.ObservableArray([]);
            creditSummaryVM.search = search;
            creditSummaryVM.filterEnabled = false;
            creditSummaryVM.toggle = toggle;
            creditSummaryVM.isOpen = isOpen;
            var exportLoanApplicationNumber = null;
            var exportCulture = null;
            creditSummaryVM.clear = clear;
            creditSummaryVM.culture = (localStorage.getItem("culture"));
            var LoggedInUserConfigurations = cacheStore.get("Configurations");
            var TenantsList = TMX_FINANCE_CONSTANTS.TENANTS;
            var currentTenant = tmxUtility.getConfigurationValue(LoggedInUserConfigurations, 'INTEGRATION_TENANT').toLowerCase();
            creditSummaryVM.formatColumnName = tmxUtility.formatColumnName;
            var spName = "sp_credit_summary";

            if (currentTenant == TenantsList.VITAS_EG) {
                spName = "sp_credit_summary_vitas_eg";
            }


            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
        //   creditSummaryVM.disableExport = true;
                creditSummaryVM.LoanApplicationNumber = null;
        // creditSummaryVM.BranchId=null;
        // creditSummaryVM.NationalId=null;
                creditSummaryVM.container.creditSummaryGrid.dataSource.read();
            }


            BranchService.getByAction('', true).then(function (response) {
                decorateForSelect(response.data);
                creditSummaryVM.Branches = response.data;
            });

            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.LookupId = obj.CompanyBranchId;
                        obj.VisibleValue = obj.BranchName;
                        obj.HiddenValue = obj.BranchCode;
                    }
                );
            }

            function toggle(navID) {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function () { });
            }

            creditSummaryVM.exportToPdf = exportToPdf;

            function search() {
                creditSummaryVM.container.creditSummaryGrid.dataSource.read();
                creditSummaryVM.filterEnabled = true;
                exportLoanApplicationNumber = angular.copy(creditSummaryVM.LoanApplicationNumber);
                exportCulture = angular.copy(creditSummaryVM.culture);
            }

            function exportToPdf() {
                var loanapplicationnumber = exportLoanApplicationNumber
                    ? exportLoanApplicationNumber
                    : null;
                var culture = exportCulture
                    ? exportCulture :
                    null;

                CreditSummaryService.exportCreditSummary(loanapplicationnumber, culture);
            }

            creditSummaryVM.formatlabel = function (data) {
        // console.log(data);
                return data
                    .replace(/_/g, " ");
            }

            creditSummaryVM.formatLabelItem = function (item) {
                if (!angular.isDefined(item) || item == null || item.toString().trim() == "") {
                    return 'N/A';
                }
                return item.replace(/_/g, ' ');
            }

            creditSummaryVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            var loanapplicationnumber = null;
                            var culture = null;

                            if (
                                angular.isUndefined(creditSummaryVM.LoanApplicationNumber) ||
                (creditSummaryVM.LoanApplicationNumber == "" ||
                  creditSummaryVM.LoanApplicationNumber == 0)
                            ) {
                                loanapplicationnumber = 0;
                            }
                            else {
                                loanapplicationnumber = creditSummaryVM.LoanApplicationNumber
                                    ? creditSummaryVM.LoanApplicationNumber
                                    : null;
                            }


                            if (
                                angular.isUndefined(creditSummaryVM.culture) ||
                (creditSummaryVM.culture == "")
                            ) {
                                culture = "";
                            }
                            else {
                                culture = creditSummaryVM.culture
                                    ? creditSummaryVM.culture
                                    : null;
                            }


                            var objArgs = {
                                LoanApplicationNumber: loanapplicationnumber,
                                culture: culture

                            };

                            var filters = {
                                StoredProcedure: spName,
                                Arguments: objArgs,
                                ReportName: "Credit_Summary"
                            };

                            var jsonString = JSON.stringify(filters)
                                .replace(/:/g, "~")
                                .replace(/,/g, "^");

                            creditSummaryVM.o = angular.copy(o);
                            creditSummaryVM.filters = creditSummaryVM.o.data.filter;
                            firebase.logTmxEvent('report',{name:'Credit Summary Report'});
                            CreditSummaryService.getByParams(o, true, "/ReportDataSourceResult/" + jsonString).then(function (response) {

                                o.success(response);
                                creditSummaryVM.filterEnabled = true;
                            });
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 15,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "CreditSummary.xlsx"
                },
                excelExport: function (e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
                        row.cells[0].value = creditSummaryVM.formatLabelItem(row.cells[0].value);

                    }
                    columns.forEach(function (column) {
                        delete column.width;
                        column.autoWidth = true;
                    }


                    );
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: CreditSummaryService.GridColumns
            };
  
        }]);
}) ();
